import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography, Box, CircularProgress } from "@material-ui/core"
import { green } from "@material-ui/core/colors"

// Components
import Button from "components/shared/Button"

// Icons
import CheckIcon from "@material-ui/icons/Check"

// Helpers
import { getPluralOrSingular } from "shared/helpers"

const useStyles = makeStyles(theme => ({
  greenIcon: {
    color: green[500],
    marginRight: theme.spacing(2)
  },
  enrollBtn: {
    backgroundImage: theme.gradients.primaryButton,
    color: theme.palette.common.white,
    padding: theme.spacing(1.5, 6),
    boxShadow: theme.shadows[25],
    "&:disabled": {
      color: theme.palette.common.white
    }
  },
  certificateTemplate: {
    width: 450,
    [theme.breakpoints.down("xs")]: {
      width: 300
    }
  },

  // Helpers
  fontWeightBolder: {
    fontWeight: theme.typography.fontWeightBolder
  }
}))

const points = [
  "Get skilled with the best curriculum available globally",
  "Connect with the best teachers across the world",
  "Create your skill profile and we’ll show it to the employers",
  "Become the teacher you aspire to be",
  "Access the best jobs in the industry"
]

export default function ItemCertificate({
  img,
  handleClick,
  is_enrolled,
  number_of_enrollments,
  buyLoading
}) {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <Grid
      container
      direction="row-reverse"
      alignItems="center"
      justifyContent="center"
      spacing={4}
    >
      <Grid item xs="auto" lg={5}>
        <img
          alt="certificate"
          className={classes.certificateTemplate}
          src={img}
        />
      </Grid>
      <Grid item xs="auto" lg={7}>
        <Grid container direction="column" spacing={3}>
          <Grid item>
            <Typography variant="h4" className={classes.fontWeightBolder}>
              {t("Start your teaching career with Suraasa")}
            </Typography>
          </Grid>
          <Grid item container spacing={1} direction="column">
            {points.map(point => (
              <Grid item key={point}>
                <Typography variant="h6">
                  <CheckIcon className={classes.greenIcon} />
                  {point}
                </Typography>
              </Grid>
            ))}
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              disabled={is_enrolled || buyLoading}
              onClick={handleClick}
              className={classes.enrollBtn}
            >
              {/* TBD */}
              <Typography variant="body1">
                {is_enrolled ? t("Enrolled") : t("Enroll Now")}
              </Typography>
              {buyLoading && (
                <CircularProgress
                  color="white"
                  size="20px"
                  style={{
                    marginLeft: "12px"
                  }}
                />
              )}
            </Button>
            {number_of_enrollments > 300 && (
              <Typography variant="body2">
                <Box ml={2} component="span">
                  {getPluralOrSingular("Learner", number_of_enrollments)}
                  &nbsp;Enrolled
                </Box>
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

ItemCertificate.propTypes = {
  img: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  is_enrolled: PropTypes.bool,
  number_of_enrollments: PropTypes.number
}

ItemCertificate.defaultProps = {
  img: "/store/assets/images/CourseCertificateTemplate-min.png",
  is_enrolled: false,
  number_of_enrollments: 0
}
